import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../modules';
import { editContent } from '../../modules/editor';
import FieldSection from './FieldSection';
import useAlert from '../../hooks/useAlert';

declare var daum: any;

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentMap({ selectedContentId, currentContent }: Props) {
	const dispatch = useDispatch();
	const Alert = useAlert();

	const [addr, setAddr] = useState('');

	useEffect(() => {
		setAddr(currentContent?.content.content[0].imageAlt);
	}, [currentContent]);

	return (
		<>
			<div 
				id="staticMap" 
				style={{
					width:'630px',
					height:'380px',
					visibility: 'hidden',
					position: 'absolute',
					zIndex: -1
				}}
			></div>
		</>
	);
}

export default SelectedContentMap;